import { ChevronsUpDown } from "lucide-react"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuLabel,
} from "@/components/ui/dropdown-menu"
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"

export type Mode = "policy-engine" | "banker-interface" | "schema-management"

export interface SidebarHeaderProps {
  mode: Mode
  onModeChange?: (mode: Mode) => void
  isCollapsed?: boolean
}

export function AppLogo() {
  return (
    <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-[4.19px] bg-black">
      <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.97291 0.905762C4.26715 0.905762 4.4563 0.989829 4.54037 1.15796C4.62444 1.3261 4.66647 1.52226 4.66647 1.74644V8.93421C4.94669 8.37376 5.332 7.91839 5.8224 7.56811C6.3268 7.21783 6.97132 7.04269 7.75595 7.04269C8.80679 7.04269 9.62645 7.28088 10.2149 7.75726C10.8174 8.21964 11.1186 8.99726 11.1186 10.0901V14.8189C11.1186 15.0571 11.2167 15.2323 11.4129 15.3444C11.6231 15.4424 11.8893 15.5055 12.2115 15.5335C12.3096 15.5335 12.4007 15.5615 12.4847 15.6176C12.5828 15.6736 12.6319 15.7647 12.6319 15.8908C12.6319 16.0309 12.5898 16.136 12.5058 16.206C12.4217 16.2621 12.3236 16.2901 12.2115 16.2901H7.71392C7.60183 16.2901 7.50375 16.2621 7.41968 16.206C7.33561 16.136 7.29358 16.0309 7.29358 15.8908C7.29358 15.7647 7.33561 15.6736 7.41968 15.6176C7.51776 15.5615 7.61584 15.5335 7.71392 15.5335C7.99414 15.5055 8.18329 15.4424 8.28137 15.3444C8.39346 15.2323 8.44951 15.0571 8.44951 14.8189V10.3213C8.44951 10.0551 8.4355 9.7959 8.40747 9.5437C8.39346 9.2915 8.34442 9.06732 8.26035 8.87116C8.1903 8.66099 8.07821 8.49286 7.92408 8.36675C7.76996 8.24065 7.55979 8.1776 7.29358 8.1776C6.83121 8.1776 6.43889 8.31071 6.11663 8.57692C5.80839 8.82913 5.54918 9.15138 5.33901 9.5437C5.14285 9.922 4.98873 10.3353 4.87664 10.7837C4.77856 11.218 4.7085 11.6174 4.66647 11.9817V14.8189C4.66647 15.0571 4.72251 15.2323 4.8346 15.3444C4.94669 15.4424 5.14285 15.5055 5.42308 15.5335C5.52116 15.5335 5.61223 15.5615 5.6963 15.6176C5.78036 15.6736 5.8224 15.7647 5.8224 15.8908C5.8224 16.0309 5.78036 16.136 5.6963 16.206C5.61223 16.2621 5.52116 16.2901 5.42308 16.2901H0.925464C0.827386 16.2901 0.729307 16.2621 0.631228 16.206C0.547161 16.136 0.505127 16.0309 0.505127 15.8908C0.505127 15.7647 0.554166 15.6736 0.652245 15.6176C0.750324 15.5615 0.841397 15.5335 0.925464 15.5335C1.23371 15.5055 1.49292 15.4424 1.70309 15.3444C1.91326 15.2323 2.01834 15.0571 2.01834 14.8189V2.39796C2.01834 2.15977 1.91326 1.98463 1.70309 1.87254C1.49292 1.76045 1.23371 1.6974 0.925464 1.68339C0.841397 1.68339 0.750324 1.65536 0.652245 1.59932C0.554166 1.52926 0.505127 1.42418 0.505127 1.28407C0.505127 1.15796 0.547161 1.06689 0.631228 1.01085C0.729307 0.94079 0.827386 0.905762 0.925464 0.905762H3.97291Z" fill="white"/>
        <path d="M13.3614 0.290039C13.3831 2.72534 15.3637 4.69287 17.8042 4.69287C17.8173 4.69287 17.8304 4.69245 17.8436 4.69233C17.8436 4.69265 17.8437 4.69297 17.8437 4.69329C17.8305 4.69318 17.8173 4.69287 17.8042 4.69287C15.3503 4.69287 13.361 6.68208 13.361 9.13595C13.361 9.14912 13.3613 9.16232 13.3614 9.17546C13.3611 9.17546 13.3608 9.17547 13.3604 9.17546C13.3606 9.16232 13.361 9.14912 13.361 9.13595C13.3609 6.69558 11.3935 4.71501 8.95825 4.69329C8.95826 4.69297 8.95825 4.69265 8.95825 4.69233C11.38 4.67073 13.3388 2.71193 13.3604 0.290146C13.3608 0.290143 13.3611 0.290042 13.3614 0.290039Z" fill="white"/>
      </svg>
    </div>
  )
}

const modeConfig = {
  "policy-engine": {
    primary: "Policy Engine",
    secondary: null,
  },
  "banker-interface": {
    primary: "Banker Interface",
    secondary: null,
  },
  "schema-management": {
    primary: "Schema Management",
    secondary: null,
  },
}

export function SidebarHeaderComponent({ mode, onModeChange, isCollapsed = false }: SidebarHeaderProps) {
  const isPolicyEngine = mode === "policy-engine"
  const config = modeConfig[mode]

  const button = (
    <SidebarMenuButton
      className={`h-auto w-full gap-3 rounded-md px-3 py-2 justify-center data-[state=open]:bg-bg-raised focus-visible:outline-none transition-colors duration-150 ${onModeChange ? "hover:bg-bg-raised cursor-pointer focus-visible:ring-2 focus-visible:ring-text-subtle focus-visible:ring-offset-2 focus-visible:ring-offset-bg-subtle" : "cursor-default pointer-events-none"}`}
    >
      <AppLogo />
      <div className={`hidden flex-1 flex-col justify-center gap-0 min-w-0 ${!isCollapsed ? 'md:flex' : ''}`}>
        <span className="whitespace-nowrap text-sm font-normal leading-[21px] tracking-[0.07px] text-text-default">
          {config.primary}
        </span>
        <span className="text-xs font-normal leading-[18px] tracking-[0.18px] text-text-subtlest">
          Hark
        </span>
      </div>
      {onModeChange && (
        <ChevronsUpDown className={`hidden h-5 w-5 text-text-default ${!isCollapsed ? 'md:block' : ''}`} />
      )}
    </SidebarMenuButton>
  )

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        {onModeChange ? (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>{button}</DropdownMenuTrigger>
            <DropdownMenuContent
              align="start"
              side="right"
              alignOffset={0}
              sideOffset={8}
              className="w-[200px] rounded-lg border border-border-default bg-background-general-card p-[2px] shadow-[0px_2px_4px_-2px_rgba(0,0,0,0.10)]"
            >
              <div className="flex flex-col">
                <DropdownMenuLabel className="min-h-8 px-2 py-[5.50px] text-xs font-normal leading-[18px] tracking-[0.18px] text-text-subtlest">
                  Select
                </DropdownMenuLabel>
                <DropdownMenuItem
                  onClick={() => onModeChange("policy-engine")}
                  className={`min-h-8 rounded-md px-2 py-[5.50px] mb-1 hover:bg-bg-emphasized focus:bg-bg-emphasized cursor-pointer ${
                    isPolicyEngine ? "bg-bg-emphasized" : ""
                  }`}
                >
                  <div className="flex flex-1 items-center justify-start gap-2">
                    <div className="flex flex-1 flex-col items-start justify-center">
                      <span className="text-sm font-normal leading-[21px] tracking-[0.07px] text-text-default">
                        Policy Engine
                      </span>
                    </div>
                  </div>
                </DropdownMenuItem>
                <DropdownMenuItem
                  onClick={() => onModeChange("banker-interface")}
                  className={`min-h-8 rounded-md px-2 py-[5.50px] hover:bg-bg-emphasized focus:bg-bg-emphasized cursor-pointer ${
                    !isPolicyEngine ? "bg-bg-emphasized" : ""
                  }`}
                >
                  <div className="flex flex-1 items-center justify-start gap-2">
                    <div className="flex flex-1 flex-col items-start justify-center">
                      <span className="text-sm font-normal leading-[21px] tracking-[0.07px] text-text-default">
                        Banker Interface
                      </span>
                    </div>
                  </div>
                </DropdownMenuItem>
              </div>
            </DropdownMenuContent>
          </DropdownMenu>
        ) : (
          button
        )}
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
